import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { defaultRoutes } from 'components/MainRouter/constants';

// Should be removed when akira and mobile will use
// https://example.com/resetPassword?rptk=foo
// link insted of
// https://example.com/lorem?cmd=resetPassword&token=foo
const TemporaryPopupToPageRedirect = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isResetPassword = new URLSearchParams(search).get('cmd') === 'resetPassword';

  if (isResetPassword) {
    searchParams.delete('cmd');

    const newSearch = searchParams.toString();

    return <Redirect to={`${defaultRoutes.resetPassword}${newSearch ? '?' : ''}${newSearch}`} />;
  }

  return null;
};

export default TemporaryPopupToPageRedirect;
